import React from 'react';

export const NoConnectionIllustration = () => (
    <svg width='128' height='128' viewBox='0 0 128 128' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M106.327 66.6588L112.712 60.69C107.438 55.0451 101.423 50.1405 94.8522 46.115L46.1299 91.9222L48.6022 94.5481L61.7691 108.533L65.4566 105.069L80.8786 90.5804C77.5472 87.0638 73.4292 84.2414 68.8947 82.5294C72.8978 84.0305 77.3203 85.0853 81.3722 84.9547C82.0604 84.9325 82.738 84.8761 83.401 84.7819C84.3697 84.6443 85.3072 84.4259 86.2016 84.1155C87.756 83.5761 89.18 82.7586 90.4102 81.604L96.7955 75.6351C93.4368 72.0925 89.7122 68.9615 85.6215 66.3333C89.3978 68.7468 93.7875 70.1063 97.8426 69.97C98.4141 69.9508 98.9789 69.9018 99.5345 69.822C100.513 69.6813 101.462 69.4447 102.369 69.1053C103.819 68.5622 105.158 67.7559 106.327 66.6588Z'
            fill='#1C58D9'
            fillOpacity='0.12'
        />
        <path
            d='M112.712 60.6899L106.327 66.6585C105.158 67.7556 103.819 68.5619 102.368 69.105C101.462 69.4444 100.513 69.681 99.5341 69.8217L105.484 69.0093C108.108 68.6697 110.534 67.6488 112.484 65.8177L118.87 59.8489L112.712 60.6899Z'
            fill='#1C58D9'
            fillOpacity='0.38'
        />
        <path
            d='M61.769 108.533L80.8782 90.5801L87.036 89.7393L67.9265 107.692L61.769 108.533Z'
            fill='#1C58D9'
            fillOpacity='0.38'
        />
        <path
            d='M83.401 84.7817L89.3745 83.9659C89.4359 83.9579 89.4971 83.9495 89.5582 83.9409C92.2104 83.564 94.6295 82.582 96.5676 80.7629L102.953 74.7941L96.7955 75.6349L90.4099 81.6037C89.1797 82.7584 87.7557 83.5758 86.2013 84.1152C85.3069 84.4256 84.3697 84.6441 83.401 84.7817Z'
            fill='#1C58D9'
            fillOpacity='0.38'
        />
        <path
            d='M94.853 46.115L101.011 45.2737C107.581 49.2992 113.596 54.2042 118.871 59.8491L112.713 60.69L112.712 60.6901C107.438 55.0453 101.423 50.1404 94.853 46.115Z'
            fill='#1C58D9'
            fillOpacity='0.38'
        />
        <path
            d='M46.13 91.9226L48.6024 94.5486L37.4349 105.055L31.2773 105.896L34.9752 102.417L46.13 91.9226Z'
            fill='#1C58D9'
        />
        <path
            d='M96.7956 24.1371L94.9911 22.2401L101.148 21.3992L102.953 23.2962C108.505 29.2188 108.737 38.0101 103.462 42.961L101.01 45.2741L94.8523 46.1154L97.3046 43.8019C102.364 39.0534 102.358 30.7721 97.4499 24.8774C97.2407 24.6262 97.0226 24.3793 96.7956 24.1371Z'
            fill='#1C58D9'
        />
        <path
            d='M68.8955 82.53C72.8986 84.0312 77.3211 85.0859 81.373 84.9553C83.4329 86.3328 85.3372 87.9461 87.0368 89.7402L80.8794 90.581C77.548 87.0645 73.43 84.242 68.8955 82.53Z'
            fill='#1C58D9'
            fillOpacity='0.64'
        />
        <path
            d='M85.6224 66.3335C89.3987 68.747 93.7883 70.1065 97.8434 69.9702C99.6318 71.4759 101.335 73.0874 102.954 74.7945L96.7963 75.6353C93.4377 72.0927 89.713 68.9617 85.6224 66.3335Z'
            fill='#1C58D9'
            fillOpacity='0.64'
        />
        <path
            d='M34.9751 102.418L46.1299 91.923L94.8522 46.1158L97.3045 43.8023C102.364 39.0538 102.358 30.7725 97.4498 24.8778C97.2406 24.6266 97.0225 24.3797 96.7956 24.1375L94.991 22.2405L28.9638 84.3347C23.689 89.2856 23.9203 98.0769 29.4727 103.999L31.2773 105.897L34.9751 102.418Z'
            fill='#1C58D9'
            fillOpacity='0.64'
        />
        <path
            d='M77.9983 38.2212L77.9599 38.2041C72.1299 36.2145 66.0222 34.9189 59.7758 34.3637C56.9 34.1164 54.0673 34.0366 51.2861 34.116C49.7846 34.1588 48.2982 34.2481 46.8281 34.3824C45.8331 34.4733 44.8255 34.5876 43.8459 34.7195C43.77 34.7297 43.6741 34.7429 43.5982 34.7533C29.7492 36.6722 17.4913 42.6443 8 51.5298L24.8774 69.428L24.8782 69.4273L24.7992 69.3438C29.9676 64.4895 36.3691 60.9042 43.5502 58.9561C47.9744 57.7559 52.6969 57.1673 57.6024 57.3155L57.6917 57.3183L77.9983 38.2212Z'
            fill='#1C58D9'
            fillOpacity='0.12'
        />
        <path
            d='M80.2068 36.1441L77.9986 38.2208L77.9601 38.2037C72.1301 36.2141 66.0225 34.9185 59.776 34.3633C55.3477 33.9826 51.0214 33.9988 46.828 34.382C45.833 34.473 44.8455 34.5846 43.8658 34.7164L49.3592 33.9681C54.6695 33.201 60.2165 33.0309 65.9333 33.5224C70.7972 33.9547 75.5768 34.8359 80.2068 36.1441Z'
            fill='#1C58D9'
            fillOpacity='0.38'
        />
        <path
            d='M43.5981 34.753C43.6873 34.7406 43.7765 34.7284 43.8658 34.7164L43.5981 34.753Z'
            fill='#1C58D9'
            fillOpacity='0.38'
        />
        <path
            d='M34.2598 79.3526L24.7993 69.342C29.9677 64.4877 36.3692 60.9024 43.5503 58.9543C47.9745 57.7541 52.6969 57.1656 57.6025 57.3137L57.6917 57.3165L34.2598 79.3526Z'
            fill='#1C58D9'
            fillOpacity='0.12'
        />
    </svg>
);
